var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Editar Equipo" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  on: { click: _vm.editar }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Editar Equipo" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.tipoeqcodigo.label,
                                        disabled: "",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.tipoeqcodigo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipoeqcodigo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipoeqcodigo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.nombreEquipo.label,
                                        disabled: _vm.ocultar,
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.nombreEquipo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombreEquipo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.nombreEquipo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.nombreCRM.label,
                                        disabled: _vm.ocultar,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.nombreCRM.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombreCRM,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.nombreCRM.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.nombreINET.label,
                                        disabled: _vm.ocultar,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.nombreINET.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombreINET,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.nombreINET.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.clase.label,
                                        items: _vm.optionslist,
                                        disabled: _vm.ocultar,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.clase.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.clase,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.clase.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.fechaModifica.label,
                                        disabled: "",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.fechaModifica.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.fechaModifica,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.fechaModifica.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.usuarioModifica.label,
                                        disabled: "",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.usuarioModifica.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.usuarioModifica,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.usuarioModifica.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.estado.label,
                                        items: _vm.optionslist_2,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.estado.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.estado,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.estado.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.tipoeqid_r.label,
                                        items: _vm.equipos_totales,
                                        "item-text": "tipoeqname",
                                        "item-value": "tipoeqid",
                                        disabled: _vm.ocultar,
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.formFields.tipoeqid_r.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipoeqid_r,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipoeqid_r.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.tipoeqcuenta_inet
                                            .label,
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.tipoeqcuenta_inet
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipoeqcuenta_inet,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipoeqcuenta_inet.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        label: _vm.formFields.seriado.label,
                                        disabled: _vm.ocultar,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.seriado.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.seriado,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.seriado.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            ),
                            _c("v-divider", { staticClass: "mt-3 mb-2" }),
                            _c(
                              "FormFieldsContainer",
                              { attrs: { "mb-3": "" } },
                              [
                                _c("h2", { staticClass: "ml-2" }, [
                                  _vm._v("Agregar cuenta facturación INET")
                                ]),
                                _c("v-flex", { attrs: { sm10: "", md10: "" } }),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Cuenta INET" },
                                      model: {
                                        value: _vm.tipoeqcuenta_inet_new,
                                        callback: function($$v) {
                                          _vm.tipoeqcuenta_inet_new = $$v
                                        },
                                        expression: "tipoeqcuenta_inet_new"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Plataforma",
                                        items: _vm.plataformas,
                                        "item-text": "configvalor",
                                        "item-value": "configid",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.plataforma,
                                        callback: function($$v) {
                                          _vm.plataforma = $$v
                                        },
                                        expression: "plataforma"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm2: "", md2: "", "mt-2": "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "btn-crear v-btn theme--light",
                                        on: {
                                          click: function($event) {
                                            return _vm.addDevice()
                                          }
                                        }
                                      },
                                      [_vm._v("agregar")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c("br"),
                            _c(
                              "div",
                              {
                                staticClass: "modalCrearOC",
                                staticStyle: { height: "100% !important" }
                              },
                              [
                                _c("MantenedorGridSinCodigo", {
                                  staticStyle: {
                                    "font-family": "'Asap' sans-serif"
                                  },
                                  attrs: {
                                    gridOptions: _vm.gridOptions,
                                    "funcionalidad-id": _vm.funcionalidad
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.dialog2
        ? _c("VerEditarModalInet", {
            attrs: { codigoEquipo: _vm.codigoEquipo, id_equipo: _vm.id_equipo },
            on: {
              cerrarCrear: _vm.handleCierreModalCrear,
              getCuentasInet: _vm.getCuentasInet
            }
          })
        : _vm._e(),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: "Eliminar Coordinador",
          mensaje:
            "¿Estás Seguro de que deseas eliminar la cuenta INET " +
            _vm.cuentaInetPlataforma +
            " de la plataforma " +
            _vm.plataformaNombre +
            "?",
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleDeleteCoor($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }